import React from 'react';
import { Box } from '@chakra-ui/react';

import { EquipmentLocation, PaidInstallation, UserInfo } from '@app/api/models';
import { entityBaseBodyRender, dateTimeBodyRender, TableColumn} from '@app/components/common/table';
import { Txt } from '@app/components/common';
import { entityAmountRender } from '@app/components/common/table/body-renders/amount';

import { OutletColumn } from '../components/outlet-column';

export const columns: TableColumn<PaidInstallation>[] = [
  {
    name: 'id',
    label: '#',
    options: {
      filter: false,
      sort: true,
    },
  },
  {
    name: 'outlet',
    label: 'Торговая точка',
    options: {
      filter: {
        name: 'outlet_id',
        type: 'outlet',
      },
      sort: false,
      customBodyRender: OutletColumn,
    },
  },
  {
    name: 'distributor',
    label: 'Дистрибьютор',
    options: {
      filter: {
        name: 'distributor_id',
        sourceName: 'distributor',
        type: 'autocomplete'
      },
      sort: true,
      customBodyRender: entityBaseBodyRender(true),
    },
  },
  {
    name: 'sales_director',
    label: 'Директор по продажам',
  },
  {
    name: 'regional_director',
    label: 'Директор региона',
  },
  {
    name: 'regional_manager',
    label: 'Региональный менеджер',
  },
  {
    name: 'territorial_manager',
    label: 'Территориальный менеджер',
  },
  {
    name: 'supervisor',
    label: 'Супервизор',
  },
  {
    name: 'route_number',
    label: 'Маршрут',
    options: {
      filter: {
        name: 'route_number_id',
        sourceName: 'route_number',
        type: 'autocomplete-paginated',
      },
      customBodyRender: entityBaseBodyRender(true),
    },
  },
  {
    name: 'period_from_date',
    label: 'Дата начала',
    options: {
      filter: {
        type: 'date',
        name: 'period_from_date',
      },
      sort: true,
      customBodyRender: dateTimeBodyRender(false, true),
    },
  },
  {
    name: 'period_to_date',
    label: 'Дата окончания',
    options: {
      filter: {
        type: 'date',
        name: 'period_to_date',
      },
      sort: true,
      customBodyRender: dateTimeBodyRender(false, true),
    },
  },
  {
    name: 'type',
    label: 'Тип установки',
    options: {
      filter: {
        name: 'type_id',
        sourceName: 'installation_type',
        type: 'multi-select',
      },
      sort: false,
      customBodyRender: entityBaseBodyRender(true),
    },
  },
  {
    name: 'quantity',
    label: 'Количество ХО за которое платим',
    options: {
      filter: false,
      sort: true,
    },
  },
  {
    name: 'amount',
    label: 'Сумма выплаты',
    options: {
      filter: false,
      sort: true,
      customBodyRender: entityAmountRender(),
    },
  },
  {
    name: 'compensation_date',
    label: 'Дата выплаты',
    options: {
      filter: {
        type: 'date',
      },
      sort: true,
      customBodyRender: dateTimeBodyRender(false, true),
    },
  },
  {
    name: 'create_dt',
    label: 'Дата создания',
    options: {
      filter: {
        type: 'date-range',
        name: 'create_date_range',
        onApply: (value) => value ? [value[0], value[1]] : undefined
      },
      sort: true,
      customBodyRender: dateTimeBodyRender(false, false),
    },
  },
  {
    name: 'update_dt',
    label: 'Дата обновления',
    options: {
      filter: {
        type: 'date-range',
        name: 'update_date_range',
        onApply: (value) => value ? [value[0], value[1]] : undefined
      },
      sort: true,
      customBodyRender: dateTimeBodyRender(false, false),
    },
  },
  {
    name: 'employee',
    label: 'Сотрудник',
    options: {
      filter: true,
      sort: false,
      hidden: true,
    }
  },
];
